/* src/app/components/doc-viewer-new/dialogs/doc-viewer-add-coding-field/doc-viewer-add-coding-field.component.scss */
:host-context(:not(.dark-theme)) button.lex-dv-button:not([disabled]) {
  color: #FFF;
  background: #3949AB;
}
:host-context(:not(.dark-theme)) button.lex-dv-button[disabled] {
  color: rgba(0, 0, 0, 0.38);
  background-color: rgba(0, 0, 0, 0.12);
}
:host-context(.dark-theme) button.lex-dv-button:not([disabled]) {
  color: #FFC107;
  background: #000;
}
:host-context(.dark-theme) button.lex-dv-button[disabled] {
  color: rgba(255, 255, 255, 0.6);
  background-color: #252525;
}
mat-select,
lex-text-input {
  color: #000;
}
:host-context(.dark-theme) mat-select,
:host-context(.dark-theme) lex-text-input {
  color: #fff;
}
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
:host::ng-deep .mat-mdc-dialog-content {
  height: 320px;
  max-height: initial;
  width: 680px;
}
#form-body-left {
  border-right: 1px solid #dadada;
}
:host-context(.dark-theme) #form-body-left {
  border-right: 1px solid rgba(255, 255, 255, 0.2117647059);
}
.icon {
  --fa-primary-color: #243e90;
  --fa-secondary-color: #a6b1d2;
  --fa-secondary-opacity: 0.4;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #000;
  --fa-secondary-opacity: 1;
}
.radio-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.mat-mdc-radio-button {
  margin: 4px 2px;
}
.form-group {
  width: 260px;
}
.form-container {
  display: flex;
  flex-direction: column;
}
label {
  color: #3949AB;
  font-weight: 500;
  display: block;
  margin-bottom: 2px;
}
:host-context(.dark-theme) label {
  color: #FFC107;
}
.add-new-section-button {
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .add-new-section-button {
  color: #FFC107;
}
::ng-deep #select-section-panel::-webkit-scrollbar {
  height: 8px;
  width: 15px;
}
::ng-deep #select-section-panel::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: rgb(36, 62, 144);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep #select-section-panel::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme #select-section-panel::-webkit-scrollbar-thumb {
  background: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep .dark-theme #select-section-panel::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme #select-section-panel::-webkit-scrollbar-corner {
  background: #000;
}
/*# sourceMappingURL=doc-viewer-add-coding-field.component.css.map */
